import { useState, useCallback } from "react";

export const useHttpClient = () => {
  const [error, setError] = useState();
  // const activeHttpRequests = useRef([]);

  // useCallback is for avoiding the infinitive loop with function recreaction
  const sendRequest = useCallback (async (
    url,
    method = "GET",
    body = null,
    headers = {}
  ) => {
    // const httpAbortCtrl = new AbortController();
    // activeHttpRequests.current.push(httpAbortCtrl);

    try {
      const response = await fetch(url, {
        method,
        body,
        headers,
        // signal: httpAbortCtrl.signal
      });

      const responseData = await response.json();

      if (!response.ok) {
        throw new Error(responseData.message);
      }

      return responseData;
    } catch (err) {
      setError(err.message);
      throw err;
    }
  }, []);

  const clearError = () => {
    setError(null);    
  }

  // useEffect(() => {
  //   return () => {
  //     activeHttpRequests.current.forEach(abortCtrl => abortCtrl.abort());
  //   };
  // }, []);

  return { error, sendRequest, clearError };
};
